"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _webMessengerContext = require("../../contexts/webMessengerContext");
var _hooks = require("../../hooks");
var _useCreateAuthenticatedSession = require("../../hooks/useCreateAuthenticatedSession");
var _useSendCustomerAttributes = require("../../hooks/useSendCustomerAttributes");
var _Icon = require("../Icon");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Button = () => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    loading,
    isChatOpened,
    openChatWindow
  } = (0, _webMessengerContext.useWebMessenger)();
  (0, _useSendCustomerAttributes.useSendCustomerAttributes)();
  (0, _useCreateAuthenticatedSession.useCreateAuthenticatedSession)();
  (0, _hooks.useOpenChatQueryParamOnMount)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
    "aria-labelledby": _constants.WEB_MESSENGER_LABEL,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ButtonComponent, {
      "data-testid": _constants.WEB_MESSENGER_BUTTON,
      isChatOpened: isChatOpened,
      onClick: openChatWindow,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        isChatOpened: isChatOpened,
        loading: loading
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
        id: _constants.WEB_MESSENGER_LABEL,
        children: isChatOpened && !loading ? translations.closeChat : translations.chatWithUs
      })]
    })
  });
};
exports.Button = Button;
